import React from 'react'
import PropTypes from 'prop-types'
import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { UncontrolledPopover } from 'reactstrap'
import { Link } from 'react-router-dom'
import { ReactComponent as BackArrow } from '../../../../assets/images/common/icons/back-arrow-icon.svg'
import { ReactComponent as GolferIcon } from '../../../../assets/images/common/icons/golfer-half-icon.svg'
import { ReactComponent as TableSelectDropDownIcon } from '../../../../assets/images/common/icons/drop-down-arrow.svg'
import moment from 'moment'
import styles from './EventHeader.module.scss'
import classNames from 'classnames'

const EventHeader = ({ event, onClickBack, openEditModal, handleLogScoresClick, setShowDeleteModal }) => {
  const { t } = useTranslation()
  const timezone = useSelector(state => state.user.current_user.communities[0].timezone)
  const navigate = useNavigate()

  const eventDateInTimezone = moment(event.eventDate).tz(timezone)
  const completed = event.status === 'completed'

  const studentsStats = () => {
    let golfersCount = 0
    if (completed) {
      golfersCount = (event.students?.filter(s => s.score)?.length || 0)
      return t('events.detail.header.golfersAttended', { count: golfersCount })
    } else if (event.pairings.id !== -1) {
      golfersCount = event.students?.filter(s => s.pairingGroupId)?.length || 0
      return t('events.detail.header.golfersPaired', { count: golfersCount })
    } else {
      golfersCount = event.students?.length || 0
      return t('events.detail.header.golfersInRoster', { count: golfersCount })
    }
  }

  const navigateToEmails = () => {
    navigate('/announcements/new-campaign', { state: { smartToggle: 'email', students: event.students } })
  }

  return (
    <div className={classNames(styles.eventHeader, 'sticky-top')}>
      <div className='w-100 d-flex align-items-center '>
        <div className='col-9 d-flex align-items-center'>
          <span className='mr-3 h-75' role='button' tabIndex={0} onClick={onClickBack} onKeyDown={null}>
            <BackArrow style={{ width: '25px' }}/>
          </span>
          <span className={classNames(styles.eventTitle, 'mr-5')}>{event.name}</span>
          <span><i className='fa fa-calendar'/>{moment(eventDateInTimezone).format('dddd, MMMM D, YYYY')}</span>
          {event.location && <span><i className='fa fa-map-marker'/>{event.location}</span>}
          <span><GolferIcon fill='#fff' className='mr-2'/>{studentsStats()}</span>
        </div>
        <div className='col-3'>
          { event.status === 'completed' ?
            <div className='d-flex justify-content-center align-items-center pull-right'>
              <button id='eventMenuButton' className='btn btn-primary pl-3 pr-3 pull-right'>
                <div className='d-flex align-items-center'>
                  <span className='mr-2'>{t('events.detail.header.manageEvent')}</span>
                  <TableSelectDropDownIcon stroke='#fff' style={{ marginLeft: '2px' }}/>
                </div>
              </button>
              <UncontrolledPopover
                placement='bottom'
                target='eventMenuButton'
                trigger='legacy'
              >
                <div className={classNames('d-flex flex-column', styles.headerButtonActions)}>
                  <p aria-hidden='true' onClick={() => setShowDeleteModal(true)}>{t('events.common.deleteEvent')}</p>
                  <p aria-hidden='true' onClick={() => openEditModal({ action: 'Edit Results' })}>{t('events.detail.header.editResults')}</p>
                </div>
              </UncontrolledPopover>
            </div>
            :
            event.status === 'draft' ?
              null
              :
              <div>
                <button id='logEventButton' className='btn btn-primary pl-3 pr-3 pull-right'>
                  <div className='d-flex align-items-center'>
                    <span className='mr-2'>{t('events.detail.header.manageEvent')}</span>
                    <TableSelectDropDownIcon stroke='#fff' style={{ marginLeft: '2px' }}/>
                  </div>
                </button>
                <UncontrolledPopover
                  placement='bottom'
                  target='logEventButton'
                  trigger='legacy'
                >
                  <div className={classNames('d-flex flex-column', styles.headerButtonActions)}>
                    <p aria-hidden='true' onClick={() => openEditModal({ action: !completed ? 'Edit Roster' : '' })}>
                      {t('events.detail.header.editRoster')}
                    </p>
                    <Link to={`/series/${event.series.id}/edit?step=2`}>{t('events.detail.header.editEvent')}</Link>
                    <p aria-hidden='true' onClick={navigateToEmails}>{t('events.common.sendAnEmail')}</p>
                    <p aria-hidden='true' onClick={() => navigate('manage-pairings')}>{t('events.detail.header.managePairings')}</p>
                    <p aria-hidden='true' onClick={handleLogScoresClick}>{t('events.common.logScores')}</p>
                  </div>
                </UncontrolledPopover>
              </div>
          }
        </div>
      </div>
    </div>
  )
}

EventHeader.propTypes = {
  event: PropTypes.object.isRequired,
  onClickBack: PropTypes.func.isRequired,
  openEditModal: PropTypes.func.isRequired,
  handleLogScoresClick: PropTypes.func.isRequired,
  setShowDeleteModal: PropTypes.func.isRequired,
}

export default EventHeader
